import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MenuIcon from '@mui/icons-material/Menu';
import { CssBaseline, Divider, Grid, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar } from "@mui/material";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import MuiDrawer from '@mui/material/Drawer';
import { CSSObject, Theme, styled, useTheme } from '@mui/material/styles';
import { Box } from "@mui/system";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
// import TprIcon from "../assets/tpr/tpr-randomizer-logo.png";
import Block from "@mui/icons-material/Block";
import JoinInnerIcon from '@mui/icons-material/JoinInner';
import Song from "@mui/icons-material/LibraryMusic";
import LearnIcon from '@mui/icons-material/School';
import Track from "@mui/icons-material/TrackChanges";
import LoginCard from '../auth/LoginCard';
import { useQueryCheckCredentials } from '../user/UserQuery';
const drawerWidth = 240;

const openedMixin = (theme: Theme): CSSObject => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);

export default function MiniDrawer() {
    const theme = useTheme();
    const [open, setOpen] = useState(false);

    let { data: isAllowed } = useQueryCheckCredentials();

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar position="fixed" open={open} sx={{ margin: "0px" }}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        sx={{
                            marginRight: 5,
                            ...(open && { display: 'none' }),
                        }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Grid container item xs={2}>
                        <Box component="h4">
                            Zelda Randomizer

                        </Box>

                    </Grid>

                    <Grid container item xs={10} justifyContent="flex-end" >
                        <LoginCard />
                    </Grid>
                </Toolbar>
            </AppBar>
            <Drawer variant="permanent" open={open} >
                <DrawerHeader>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                    </IconButton>
                </DrawerHeader>
                <Divider />
                <List>
                    <AppDrawerItem icon={<Track />} text={"OoTR Tracker Items"} path={"/ootr/tracker/items"} drawerOpen={open} />
                    <AppDrawerItem icon={<Track />} text={"OoTR Tracker Notes"} path={"/ootr/tracker/notes"} drawerOpen={open} />
                    <AppDrawerItem icon={<Track />} text={"OoTR Tracker Ennemy"} path={"/ootr/tracker/ennemy"} drawerOpen={open} />
                    <AppDrawerItem icon={<LearnIcon />} text={"OoTR Tricks"} path={"/ootr/tricks"} drawerOpen={open} />
                    {/* <AppDrawerItem icon={<Block />} text={"OoTr Checks"} path={"/ootr/checks"} drawerOpen={open} /> */}
                    <AppDrawerItem icon={<Song />} text={"OoTr Song Tracker"} path={"/ootr/tracker/songs"} drawerOpen={open} />
                    <AppDrawerItem icon={<Block />} text={"Pick Ban"} path={"/ootr/tournoi/fr/pick-ban"} drawerOpen={open} />
                    {isAllowed && <AppDrawerItem icon={<JoinInnerIcon />} text={"Sphere Tracker"} path={"/ootr/commentary"} drawerOpen={open} />}

                </List>

            </Drawer>
        </Box>
    )
}

interface AppDrawerItemProps {
    icon: any,
    text: string,
    path: string,
    drawerOpen: boolean
}
const AppDrawerItem = (props: AppDrawerItemProps) => {

    let navigate = useNavigate();
    let { drawerOpen: open, text, icon, path } = props;

    return <ListItem key={text} disablePadding sx={{ display: 'block' }}>
        <ListItemButton
            sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
            }}
        >
            <ListItemIcon
                sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                }}
                onClick={() => navigate(path)}
            >
                {icon}
            </ListItemIcon>
            <ListItemText primary={props.text} sx={{ opacity: open ? 1 : 0 }} onClick={() => navigate(path)} />
        </ListItemButton>
    </ListItem>
}


